import { ObjetKForm, requiredRule, combineRules } from '@siclop/kstone-vue'

export class SalaryGridLevelForm extends ObjetKForm {
  salaryGridId: number = 0
  level: number = 0
  label: string = ''
  minYearsExperience: number = 0
  coefficient: number = 1.0
  grossMonthlySalary: number = 0

  static validationRules = {
    label: combineRules(requiredRule('Le libellé est obligatoire'))
  }

  constructor(data?: Partial<SalaryGridLevelForm>) {
    super(data)
    if (data) {
      this.salaryGridId = data.salaryGridId ?? 0
      this.level = data.level ?? 0
      this.label = data.label ?? ''
      this.minYearsExperience = data.minYearsExperience ?? 0
      this.coefficient = data.coefficient ?? 1.0
      this.grossMonthlySalary = data.grossMonthlySalary ?? 0
    }
  }
}
